import tahirJamalImage from "../images/pic_1.jpeg";

export default function About() {
  return (
    <>
      <div className="section-header">
        <p className="section-kicker">About</p>
        <h2 className="section-title">Software Engineer focused on real impact</h2>
        <p className="section-description">
          I design and build modern web applications that balance strong engineering foundations with
          polished, intuitive user experiences.
        </p>
      </div>

      <div className="about-layout">
        <div>
          <div className="about-text">
            <p>
              I am a Software Engineer with strong expertise in React, JavaScript, and modern web
              technologies. I specialize in building scalable web applications, designing intuitive
              user interfaces, and automating complex workflows.
            </p>
            <p>
              In the health insurance domain, I have developed 150+ responsive screens for critical
              workflows and built automation systems that significantly improved operational
              efficiency and accuracy.
            </p>
          </div>

          <div className="stats-grid grid grid-4">
            <div className="stat-card">
              <div className="stat-value">4+ yrs</div>
              <div className="stat-label">Professional experience</div>
            </div>
            <div className="stat-card">
              <div className="stat-value">150+</div>
              <div className="stat-label">Screens designed & built</div>
            </div>
            <div className="stat-card">
              <div className="stat-value">12+</div>
              <div className="stat-label">Projects shipped</div>
            </div>
            <div className="stat-card">
              <div className="stat-value">Automation</div>
              <div className="stat-label">Systems architected</div>
            </div>
          </div>
        </div>

        <div className="about-profile">
          <div className="about-avatar-shell">
            <div className="about-avatar-inner">
              <img
                src={tahirJamalImage}
                alt="Portrait of Tahir Jamal"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "24px",
                }}
              />
            </div>
          </div>
          <div className="about-avatar-label">  Based in India ·  Open to Full Time / remote roles</div>
        </div>
      </div>
    </>
  );
}
